<template>
  <div>
    <a-modal
      :title="info.isAdd ? '添加信息' : '修改信息'"
      v-model:visible="info.isShow"
      :footer="null"
      style="min-width: 800px"
    >
      <a-form :model="courseForm" ref="courseForm" :rules="rule5">
        <a-form-item
          label="课程封面"
          name="subjectInfo"
          :label-col="{ span: 3, offset: 2 }"
          :wrapper-col="{ span: 14 }"
        >
          <div class="clearfix">
            <a-upload
              list-type="picture-card"
              :file-list="imgUrl"
              :customRequest="customRequestZip"
              :before-upload="beforeUploadZip"
              @preview="handlePreview"
              :remove="removeFile"
            >
              <div v-if="imgUrl !== null && imgUrl.length < 1">
                <plus-outlined />
                <div class="ant-upload-text">上传图片</div>
              </div>
            </a-upload>
            <a-modal
              :visible="imgVisible"
              :footer="null"
              :keyboard="true"
              :maskClosable="true"
              @cancel="showImg"
            >
              <img alt="example" style="width: 100%" :src="previewImage" />
            </a-modal>
          </div>
        </a-form-item>
        <a-form-item
          label="课程ID"
          name="courseNumber"
          :label-col="{ span: 3, offset: 2 }"
          :wrapper-col="{ span: 14 }"
        >
          <a-input
            v-model:value="courseForm.courseNumber"
            placeholder="请输入课程ID"
            allow-clear
          ></a-input>
        </a-form-item>
        <a-form-item
          label="课程名称"
          name="courseName"
          :label-col="{ span: 4, offset: 1 }"
          :wrapper-col="{ span: 14 }"
        >
          <a-input
            v-model:value="courseForm.courseName"
            placeholder="请输入课程名称"
            allow-clear
          ></a-input>
        </a-form-item>
        <a-form-item
          label="课时(小时)"
          name="courseTime"
          :label-col="{ span: 4, offset: 1 }"
          :wrapper-col="{ span: 14 }"
        >
          <a-input
            v-model:value="courseForm.courseTime"
            placeholder="请输入课时"
            allow-clear
          ></a-input>
        </a-form-item>
        <a-form-item
          label="课程类型"
          name="courseType"
          :label-col="{ span: 4, offset: 1 }"
          :wrapper-col="{ span: 14 }"
        >
          <a-select
            placeholder="请选择课程类型"
            v-model:value="courseForm.courseType"
            @change="handleChangeType"
            allowClear
          >
            <a-select-option v-for="item in certificateTypeList" :key="item.id">
              {{ item.typeName }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="课程简介"
          name="courseMark"
          :label-col="{ span: 3, offset: 2 }"
          :wrapper-col="{ span: 14 }"
        >
          <a-textarea
            v-model:value="courseForm.courseMark"
            placeholder="请输入课程简介"
            type="textarea"
            :auto-size="{ minRows: 2, maxRows: 6 }"
            allow-clear
          ></a-textarea>
        </a-form-item>
         <a-form-item
          label="课程费用(元)"
          name="courseTime"
          :label-col="{ span: 4, offset: 1 }"
          :wrapper-col="{ span: 14 }"
        >
          <a-input
            v-model:value="courseForm.courseFees"
            placeholder="请输入课程费用"
            allow-clear
          ></a-input>
        </a-form-item>
        <a-form-item
          label="学习密码"
          name="courseTime"
          :label-col="{ span: 4, offset: 1 }"
          :wrapper-col="{ span: 14 }"
        >
          <a-input
            v-model:value="courseForm.courseFees"
            placeholder="请输入学习密码"
            allow-clear
          ></a-input>
        </a-form-item>
        <a-form-item
          label="是否展示"
          :wrapper-col="{ span: 14 }"
          :label-col="{ span: 4, offset: 1 }"
          name="available"
        >
          <a-radio-group v-model:value="courseForm.available">
            <a-radio value="1">是</a-radio>
            <a-radio value="0">否</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item :wrapper-col="{ offset: 8 }">
          <a-button style="margin-right:100px" @click="reset">重置</a-button>
          <a-button type="primary" @click="onSubmit">提交</a-button>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import { options, provs } from "../../../assets/province.json";
import { allcities } from "../../../assets/province.json";
import { Modal, notification } from "ant-design-vue";
export default {
  props: {
    info: {
      type: Object,
      default() {
        return {
          isAdd: true,
          isShow: false,
          isSee: false
        };
      }
    },
    certificateTypeList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    const courseTime = async (rule, value, callback) => {
      if (value === "") {
        return Promise.reject("请输入及格分数");
      } else if (isNaN(Number(value))) {
        return Promise.reject("请输入数字");
      } else if (value < 0) {
        return Promise.reject("数字必须为正数");
      } else {
        return Promise.resolve();
      }
    };
    const tryTime = async (rule, value, callback) => {
      if (value === "") {
        return Promise.reject("请输入证书有效期");
      } else if (isNaN(Number(value))) {
        return Promise.reject("请输入数字");
      } else if (value < 0) {
        return Promise.reject("数字必须为正数");
      } else {
        return Promise.resolve();
      }
    };
    const courseFees = async (rule, value, callback) => {
      if (value === "") {
        return Promise.reject("请输入课程费用");
      } else if (isNaN(Number(value))) {
        return Promise.reject("请输入数字");
      } else if (value < 0) {
        return Promise.reject("数字必须为正数");
      } else {
        return Promise.resolve();
      }
    };
    const courseMark = async (rule, value, callback) => {
      if (value.length > 200) {
        return Promise.reject("课程介绍最多500个字");
      } else {
        return Promise.resolve();
      }
    };
    return {
      rule5: {
        courseNumber: [
          { required: true, message: "请输入课程ID", trigger: "blur" }
        ],
        courseName: [
          { required: true, message: "请输入课程名称", trigger: "blur" }
        ],
        courseTime: [
          { required: true, validator: courseTime, trigger: "blur" }
        ],
        courseFees: [
          { required: true, validator: courseFees, trigger: "blur" }
        ],
        courseMark: [
          { required: false, validator: courseMark, trigger: "blur" }
        ],
        courseType: [
          { required: true, message: "请输入课程类型", trigger: "change" }
        ],
        tryTime: [{ required: true, validator: tryTime, trigger: "blur" }],
        courseVideo: [
          { required: true, message: "请上传课程视频", courseVideo: "change" }
        ]
      },
      fileCode: "",
      previewImage: "",
      courseForm: {
        cover: "",
        courseNumber: "",
        courseName: "",
        courseTime: 1,
        courseFees:0,
        courseMark: "",
        courseType: "",
        courseVideo: "",
        handoutMaterials: "",
        tryTime: 5,
        available: "1",
        id: ""
      },
      //   课程图片
      imgUrl: [],
      imgVisible: false,
      iAcceptTypeEquipZip: ["jpg", "jpeg", "png", "gif"],
      iFileList: [],
      //   课程讲义
      fileUrl: [],
      fileVisible: false,
      fileAcceptTypeEquipZip: ["pdf", "xls", "xlsx", "doc", "docx"],
      fFileList: [],
      //   课程视频
      videoUrl: [],
      videoVisible: false,
      videoAcceptTypeEquipZip: ["mp4", "WebM", "Ogg"],
      vFileList: []
    };
  },
  mounted() {
    console.log("...");
  },
  computed: {},
  watch: {},
  methods: {
    showImg() {
      this.imgVisible = false;
    },
    //   预览图片
    handlePreview(file) {
      console.log(file, "file...");
      this.previewImage = file.url || file.preview;
      this.imgVisible = true;
    },
    //   获取附件的code码
    getFileCode() {
      this.$store
        .dispatch("news/GetAttachmentCode")
        .then(res => {
          this.fileCode = res;
          //   if (res.code === 0) {
          //     this.fileCode = res;
          //     console.log(this.fileCode, "code....");
          //   } else {
          //     this.$handleErr(res);
          //   }
        })
        .catch(err => {
          this.$handleErr(err);
        });
    },
    // 上传 zip
    customRequestZip(data) {
      this.showUploadMessage = true;
      this.uploadLoadingFlag = true;
      this.secModalFlag = true;
      const formData = new FormData();
      formData.append("file", data.file);
      formData.append("attachmentCode", this.fileCode);
      formData.append("readType", "public");
      // formData.append("token", "aiufpaidfupipiu"); //随便写一个token示例
      this.$store
        .dispatch("news/UploadAttachment", formData)
        .then(res => {
          if (res.code === 0) {
            // notification["success"]({
            //   message: "上传成功"
            // });
            // res.data.forEach(item => {
            //   item.url = item.ossUrl;
            // });
            console.log(res, this.iFileList, "fileList....");
            // this.fileList[0].url = res.data.ossUrl
            res.data.name = res.data.attachmentName;
            res.data.url = res.data.ossUrl;
            this.imgUrl = [res.data];
            // console.log(res, this.fileList, "fileList....11111111");
            this.uploadMessage = res.msg;
            this.uploadSuccessFlag = "1";
          } else {
            this.uploadMessage = res.msg;
            this.$message.error("上传失败");
            this.uploadSuccessFlag = "0";
          }
          this.uploadLoadingFlag = false;
          this.secModalFlag = false;
        })
        .catch(err => {
          this.uploadLoadingFlag = false;
          this.secModalFlag = false;
          this.$message.error("调用接口失败，请联系管理员" + err);
        });
    },
    // 文件上传前的格式验证 zip
    beforeUploadZip(file) {
      this.iFileList = [...this.iFileList, file];
      const uploadSize = file.size / 1024 / 1024 < 50;
      const uploadType = file.name.substring(file.name.lastIndexOf(".") + 1);
      if (
        this.iAcceptTypeEquipZip.length > 0 &&
        this.iAcceptTypeEquipZip.indexOf(uploadType) === -1
      ) {
        this.$message.error(
          "导入文件只能是" + this.iAcceptTypeEquipZip.join("、") + "格式!"
        );
        return false;
      }
      if (!uploadSize) {
        this.$message.error("上传文件大小不能超过 50MB!");
        return false;
      }
    },
    // 删除文件
    removeFile(file) {
      this.iFileList = this.iFileList.filter(item => item.uid !== file.uid);
    },
    temp() {
      this.courseForm = {
        subjectNo: "",
        subjectName: "",
        certificateTypeId: "",
        passScore: 60,
        validity: 100,
        entryFee: 0,
        subjectInfo: "",
        id: ""
      };
      this.imgUrl = [];
    },
    // 重置
    reset() {
      this.temp();
    },
    onSubmit() {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const self = this;
      const obj = Object.assign(self.courseForm);
      let funStr = "";
      let msg = "";
      this.certificateTypeList.forEach(item => {
        if (obj.certificateTypeId === item.id) {
          obj.certificateTypeName = item.typeName;
        }
      });
      if (obj.id === "") {
        // obj.createTime = new Date();
        obj.attachmentCode = this.fileCode;
        obj.passScore = String(obj.passScore);
        funStr = "SaveExamSubject";
        msg = "添加成功";
      } else {
        funStr = "UpdateExamSubject";
        msg = "修改成功";
      }
      this.$refs.courseForm
        .validate()
        .then(() => {
          self.$store
            .dispatch(funStr, obj)
            .then(res => {
              if (res.code === 0) {
                notification["success"]({
                  message: msg
                });
                this.info.isShow = false;
                this.temp();
                // this.$emit("getList");
              } else {
                self.$handleErr(res);
              }
            })
            .catch(err => {
              self.$handleErr(err);
            });
        })
        .catch(error => {
          return false;
        });
    },
    // 设置行数据
    setRowData(rowData) {
      this.courseForm = rowData;
      this.getFile(rowData.attachmentCode);
    },
    // 通过fileCode 获取图片文件
    getFile(code) {
      if (code !== null) {
        this.$store
          .dispatch("news/GetAttachmentList", { attachmentCode: code })
          .then(res => {
            if (res.code === 0) {
              res.data[0].name = res.data[0].attachmentName;
              res.data[0].url = res.data[0].ossUrl;
              this.imgUrl = res.data;
              console.log(this.imgUrl, "url");
            } else {
              this.$handleErr(res);
            }
          })
          .catch(err => {
            this.$handleErr(err);
          });
      } else {
        // this.$message.error("附件码为空，请稍后再试或联系管理员。");
        this.imgUrl = [];
      }
    }
  },
  components: {},
  filters: {}
};
</script>
<style lang="scss" scoped></style>
